const development =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const config = {
  apiUrl: process.env.REACT_APP_API,
  subfolder:process.env.REACT_APP_SUBFOLDER,
  streamUrl:process.env.STREAMLINE_APP_API
};

export const isDev=()=> {
  return development;
}

export const appVersion:string =process.env.REACT_APP_VERSION as string;

